import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import HeaderTypography from "../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography";
import Business from "../images/v2/Pricing/Business.svg";
import Starter from "../images/v2/Pricing/Starter.svg";
import Enterprisies from "../images/v2/Pricing/Enterprisies.svg";
import pricingIcon1 from "../images/v2/Pricing/pricingIcon1.svg";
import pricingIcon2 from "../images/v2/Pricing/pricingIcon2.svg";
import pricingIcon3 from "../images/v2/Pricing/pricingIcon3.svg";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Collapse from "@material-ui/core/Collapse";
import Divider from "@material-ui/core/Divider";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CheckCircle from "@material-ui/icons/CheckCircle";
import FlashOn from "@material-ui/icons/FlashOn";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import CardMedia from "@material-ui/core/CardMedia";
import EffortlessMigration from "../images/v2/Pricing/Effortless Migration.svg";
import featuresIcon1 from "../images/v2/Pricing/featuresIcon1.svg";
import featuresIcon2 from "../images/v2/Pricing/featuresIcon2.svg";
import featuresIcon3 from "../images/v2/Pricing/featuresIcon3.svg";
import featuresIcon4 from "../images/v2/Pricing/featuresIcon4.svg";
import featuresIcon5 from "../images/v2/Pricing/featuresIcon5.svg";
import trailBazarBackground from "../images/v4/aiPage/images/trailBazarBackground.png";
import trailBazarLogo from "../images/v4/aiPage/images/trailBazarLogo.png";
import leavesLeft from "../images/v4/aiPage/icons/leavesLeft.svg";
import leavesRight from "../images/v4/aiPage/icons/leavesRight.svg";
import stars from "../images/v4/aiPage/icons/stars.svg";
import PreminentDataSecurity from "../images/v2/Pricing/Preminent Data Security.svg";
import SeamlessCustomerSupport from "../images/v2/Pricing/Seamless Customer Support.svg";
import PricingSvg from "../images/v2/Pricing/Pricing.svg";
import joinImage from "../images/v2/Pricing/Vector_3.svg";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import WhiteButton from "../components/v2/WhightButton";
import pricingImage from "../images/v2/Pricing/PricingImage.webp";
import useWidth from "../hooks/useWidth";
import SEO from "../components/SEO";
import AccordionHeader from "../components/v2/AccordionHeader";
import { Link } from "gatsby";
import IMDA_SME_Large from "../images/v2/psg/IMDA_SME_Large.webp";
import tick from "../images/v2/psg/tick.svg";
import zIndex from "@material-ui/core/styles/zIndex";
import { motion, color } from "framer-motion";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import TrustedByLogoStrip from "../components/v4/TrustedByLogoStrip/TrustedByLogoStrip";
import TestimonialSlider from "../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../components/v4/FaqSection/FaqSection";
import IMDALockup from "../components/v4/IMDALockup/IMDALockup";

const useStyles = makeStyles((theme) => ({
   SmeStyling: {
      width: "74%",
      margin: "20px auto 0",
      [theme.breakpoints.down("sm")]: {
         width: "100%",
         margin: "10px auto 0",
      },
   },
   smeFooterText: {
      [theme.breakpoints.down("sm")]: {
         fontSize: "14px",
         textAlign: "center",
      },
   },
   root: {
      background:
         "radial-gradient(ellipse at 90% 2%, rgb(229, 199, 252) 0%, transparent 35%), radial-gradient(ellipse at 4% 0%, rgba(137, 212, 212, 0.8) 0%, transparent 30%), radial-gradient(ellipse at 0% 95%, rgba(32, 142, 236, 0.15) 0%, transparent 30%), radial-gradient(ellipse at 100% 85%, rgba(229, 199, 252, 0.5) 0%, transparent 30%)",
   },
   cardPricing: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(2),
   },
   featureItemFirst: {
      borderRadius: theme.shape.borderRadius * 2.5,
      borderColor: "#e2f0ff",
      padding: theme.spacing(4),
   },
   featureItem: {
      borderLeft: "1px solid",
      borderRadius: theme.shape.borderRadius * 2.5,
      borderColor: "#e2f0ff",
      padding: theme.spacing(4),
   },
   collapseDivider: {
      backgroundColor: "#eaf0f6",
   },
   JoinRoot: {
      background:
         "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      backgroundSize: "cover",
      paddingTop: "65px",
      paddingBottom: "65px",
      "@media(max-width: 1024px)": {
         padding: "65px 15px",
      },
      "@media(max-width: 600px)": {
         padding: "40px 15px",
      },
   },
   joinHeading: {
      fontSize: "56px",
      fontWeight: 600,
      marginBottom: "48px",
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
         marginBottom: "32px",
      },
   },
   heading: {
      fontSize: 20,
      fontWeight: 600,
      flexBasis: "100%",
      flexShrink: 0,
      [theme.breakpoints.down("sm")]: {
         fontSize: 16,
         flexBasis: "100%",
      },
   },
   faqP: {
      marginTop: "-14px",
      borderTop: "solid 1px #e5e7e9",
   },
   secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
   },
   media: {
      width: 87.6,
      height: 115,
      margin: 21,
   },
   businessMedia: {
      width: 87.6,
      height: 115,
      margin: "21px 0px 40px 21px",
   },
   pricecardRoot: {
      [theme.breakpoints.down("xs")]: {
         alignItems: "center",
         flexDirection: "column",
      },
   },
   priceCard: {
      minWidth: 382,
      padding: 15,
      boxShadow: "10px 20px 50px 0 rgb(2 145 174 / 16%)",
      [theme.breakpoints.down("md")]: {
         minWidth: "313px",
      },
      [theme.breakpoints.down("sm")]: {
         minWidth: "unset",
         maxWidth: 313,
      },
      "&:hover $buyBtn": {
         color: "#FFF",
         backgroundColor: "#ff7a59",
      },
   },
   FeatureIcon: {
      color: "#009f53",
      minWidth: 38,
   },
   featureHeader: {
      color: "#009f53",
   },
   recomandIcon: {
      color: "#ffb400",
   },
   featureListItem: {
      padding: 0,
   },
   buyBtn: {
      width: 312.2,
      height: 67,
      fontSize: 18,
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
         width: 230,
      },
   },
   contactUsBtn: {
      width: 194.6,
      height: 44.1,
   },
   iconBtn: { opacity: 0.6, backgroundColor: "#eaf0f6" },
   cardHeader: {
      fontSize: 28,
      fontWeight: "bold",
   },
   expandIcon: {
      color: "#0291ae",
      fontSize: 34,
   },
   expendButton: {
      backgroundColor: "#eaf0f6",
      "&:hover": {
         background: "#a1dae2",
      },
   },
   faqRoot: {
      marginBottom: theme.spacing(2),
      borderRadius: 10,
      boxShadow: "7px 15px 20px 0 rgb(171 171 171 / 16%)",
      border: "solid 1px #e5e7e9",
      overflow: "hidden",
   },
   img: {
      width: "100%",
      height: "auto",
   },
   header: {
      paddingTop: "80px",
      marginBottom: "75px",
      "@media(max-width:768px)": {
         paddingTop: "0",
      },
      [theme.breakpoints.down("sm")]: {
         paddingTop: "32px",
      },
      [theme.breakpoints.down("xs")]: {
         paddingTop: "20px",
         marginBottom: "30px",
      },
   },
   bannerHeading: {
      fontSize: "64px",
      paddingBottom: "24px",
      "@media(max-width:1024px)": {
         fontSize: "48px",
      },
      "@media(max-width:600px)": {
         fontSize: "34px",
      },
   },
   pricingDescription: {
      color: "rgb(46, 63, 79)",
      fontSize: "18px",
      fontWeight: "400",
   },
   highlightedCard: {
      background: "linear-gradient(160deg, #0c3042 0%, #0e4a5e 100%)",
      "& $buyBtn": {
         backgroundColor: "#ffffff",
         color: "#0c3042",
         border: "none",
         "&:hover": {
            backgroundColor: "#f0f9ff",
         },
      },
   },
   enterpriseCard: {
      background: "linear-gradient(160deg, #1e0d40 0%, #3a1870 100%)",
      "& $buyBtn": {
         backgroundColor: "#ffffff",
         color: "#2d1260",
         border: "none",
         "&:hover": {
            backgroundColor: "#f5f0ff",
         },
      },
   },
   starterCard: {
      background:
         "radial-gradient(circle at top right, rgba(5, 178, 177, 0.1) 0%, transparent 60%), #ffffff",
   },
   mostPopularBadge: {
      background:
         "linear-gradient(90deg,rgba(255, 143, 97, 1) 0%, rgba(187, 104, 255, 1) 100%)",
      color: "#fff",
      borderRadius: "20px",
      padding: "4px 18px",
      fontSize: "12px",
      fontWeight: "bold",
      border: "1px solid rgba(255, 255, 255, 1)",
      zIndex: 2,
      position: "absolute !important",
      top: "0px",
      left: "50%",
      transform: "translateX(-50%)",
      whiteSpace: "nowrap",
   },
   featureChip: {
      display: "flex",
      alignItems: "center",
      background: "trasperent",
      border: "1px solid #00B661",
      borderRadius: "30px",
      padding: "8px 12px",
      gap: "8px",
   },
   gradientText: {
      background: "linear-gradient(90deg, #268BEB, #9E5AD5)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
   },
   pricingCardsContainer: {
      display: "flex",
      gap: "30px",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         alignItems: "center",
      },
   },
   newPriceCard: {
      flex: 1,
      height: "100%",
      borderRadius: "20px",
      padding: "32px 24px",
      position: "relative",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
      textAlign: "left",
      "&.glass-effect": {
         "&::before": {
            content: '""',
            position: "absolute",
            width: "500px",
            height: "500px",
            zIndex: "0",
            background: "var(--before-gradient)",
            borderRadius: "50%",
            filter: "blur(100px)",
            opacity: "1",
            left: "var(--before-left, calc(100% - 250px))",
            top: "var(--before-top, -150px)",
            transition:
               "left var(--before-transition, 0.5s) ease, top var(--before-transition, 0.5s) ease",
            pointerEvents: "none",
         },
         [theme.breakpoints.down("sm")]: {
            margin: "auto",
         },
      },
      "& > *": {
         position: "relative",
         zIndex: 1,
      },
      [theme.breakpoints.down("sm")]: {
         width: "100%",
         maxWidth: "360px",
         flex: "unset",
      },
      [theme.breakpoints.down("xs")]: {
         padding: "16px",
         maxWidth: "100%",
      },
   },
   newPriceCardMiddle: {
      paddingTop: "52px",
      paddingBottom: "52px",
   },
   newStarterCard: {
      background: "#021D1D",
      transition: "transform 0.4s ease",
      "&:hover": {
         transform: "scale(1.03)",
      },
   },
   newGrowthCard: {
      background: "rgba(1, 28, 51, 1)",
      transition: "transform 0.4s ease",
      "&:hover": {
         transform: "scale(1.03)",
      },
      "&::after": {
         content: '""',
         position: "absolute",
         width: "250px",
         height: "250px",
         borderRadius: "50%",
         background: "rgba(158, 90, 213, 0.8)",
         filter: "blur(80px)",
         bottom: "-60px",
         left: "-60px",
         pointerEvents: "none",
         zIndex: 0,
      },
      [theme.breakpoints.down("xs")]: {
         padding: "16px",
      },
   },
   newEnterpriseCard: {
      background: "rgba(33, 5, 56, 1)",
      transition: "transform 0.4s ease",
      "&:hover": {
         transform: "scale(1.03)",
      },
   },
   pricingIconCircle: {
      width: "56px",
      height: "56px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      zIndex: 1,
   },
   iconBgStarter: {
      background: "rgba(255, 255, 255, 0.2)",
   },
   iconBgDark: {
      background: "rgba(255, 255, 255, 0.2)",
   },
   featureChipsContainer: {
      gap: "12px",
   },
   cardWrapper: {
      position: "relative",
      flex: 1,
      [theme.breakpoints.down("sm")]: {
         width: "100%",
      },
   },
   cardWrapperBadge: {
      paddingTop: "16px",
   },
   cardTitle: {
      color: "#ffffff",
   },
   cardUserCount: {
      color: "#fff",
   },
   cardDescription: {
      color: "#C8D3E0",
      lineHeight: 1.6,
   },
   cardBestForLabel: {
      color: "#ffffff",
   },
   pricingReadMoreLink: {
      textDecoration: "underline",
   },
   pricingBespokeText: {
      color: "#516f90",
   },
   pricingBespokeLink: {
      color: "#0291ae",
   },
   crmAdvantageSection: {
      position: "relative",
      padding: "80px 0 260px",
      background:
         "radial-gradient(circle at 100% 0%, rgba(32, 142, 236, 0.6) 0%, transparent 35%), radial-gradient(circle at 0% 0%, rgba(31, 108, 108, 0.8) 0%, transparent 35%), #011C33",
      [theme.breakpoints.down("sm")]: {
         padding: "48px 0 30%",
      },
      [theme.breakpoints.down("xs")]: {
         padding: "48px 0 60%",
      },
      "@media(max-width:400px)": {
         padding: "48px 0 80%",
      },
   },
   awardCardOuter: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      transform: "translateY(50%)",
      zIndex: 2,
   },
   awardCardWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "48px",
      background:
         "radial-gradient(circle at 0% -20%, rgba(255, 139, 61, 0.8) 0%, transparent 35%), radial-gradient(circle at 50% 140%, rgba(32, 142, 236, 0.6) 0%, transparent 50%), radial-gradient(circle at 80% -30%, rgba(32, 142, 236, 1) 0%, transparent 38%), radial-gradient(ellipse at 28% 0%, rgba(120, 60, 168, 1) 0%, transparent 55%), #102344",
      borderRadius: "24px",
      padding: "48px",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         padding: "16px",
      },
   },
   awardCardLeft: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "16px",
   },
   awardCardHeading: {
      color: "#fff",
      fontSize: "32px",
      fontWeight: 700,
      lineHeight: 1.3,
      [theme.breakpoints.down("sm")]: {
         fontSize: "24px",
      },
   },
   awardCardText: {
      color: "rgba(255,255,255,1)",
      fontSize: "16px",
      lineHeight: 1.7,
      margin: 0,
   },
   awardCardRight: {
      flex: 1,
   },
   trailBazarCard: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      position: "relative",
      "& .leaves": {
         position: "absolute",
         height: "100%",
         top: 0,
         objectFit: "cover",
      },
      "& .leavesLeft": { left: 0 },
      "& .leavesRight": { right: 0 },
      "& .trailblazerLogo": {
         maxWidth: "220px",
         width: "100%",
         marginTop: "12px",
      },
      [theme.breakpoints.down("sm")]: {
         "& .trailblazerLogo": {
            maxWidth: "180px",
         },
      },
   },
   trailBazarInner: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "12px",
      textAlign: "center",
      position: "relative",
      zIndex: 1,
   },
   trailBazarTitle: {
      fontSize: "18px",
      fontWeight: 700,
      margin: 0,
      color: "#fff",
   },
   trailBazarDesc: {
      color: "#fff",
      maxWidth: "76%",
      fontSize: "14px",
      lineHeight: 1.6,
      margin: 0,
      [theme.breakpoints.down("xs")]: {
         maxWidth: "100%",
      },
   },
   comparisonGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1.4fr 1fr",
      gridTemplateRows: "repeat(6, auto)",
      alignItems: "stretch",
      [theme.breakpoints.down("sm")]: {
         gridTemplateColumns: "1fr",
         gridTemplateRows: "none",
         gap: "24px",
      },
   },
   featuresColumn: {
      display: "grid",
      gridRow: "1 / 7",
      gridTemplateRows: "subgrid",
      [theme.breakpoints.down("sm")]: {
         gridRow: "auto",
         gridTemplateRows: "none",
      },
   },
   pepperCloudCard: {
      background: "trasperent",
      borderRadius: "16px",
      display: "grid",
      border: "1.5px solid #0B9AA2",
      gridRow: "1 / 7",
      gridTemplateRows: "subgrid",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 8px 40px rgba(12, 48, 66, 0.5)",
      margin: "-20px 0",
      "&.glass-effect": {
         "&::before": {
            content: '""',
            position: "absolute",
            width: "350px",
            height: "350px",
            zIndex: 0,
            background: "var(--before-gradient, rgba(5, 178, 177, 0.5))",
            borderRadius: "50%",
            filter: "blur(80px)",
            left: "var(--before-left, calc(100% - 175px))",
            top: "var(--before-top, -120px)",
            transition:
               "left var(--before-transition, 0.5s) ease, top var(--before-transition, 0.5s) ease",
            pointerEvents: "none",
         },
      },
      "&::after": {
         content: '""',
         position: "absolute",
         width: "220px",
         height: "220px",
         zIndex: 0,
         background: "rgba(158, 90, 213, 0.45)",
         borderRadius: "50%",
         filter: "blur(70px)",
         bottom: "-70px",
         left: "-70px",
         pointerEvents: "none",
      },
      "& > *": {
         position: "relative",
         zIndex: 1,
      },
      [theme.breakpoints.down("sm")]: {
         gridRow: "auto",
         gridTemplateRows: "none",
         margin: "0",
      },
   },
   otherCrmsColumn: {
      display: "grid",
      gridRow: "1 / 7",
      gridTemplateRows: "subgrid",
      [theme.breakpoints.down("sm")]: {
         gridRow: "auto",
         gridTemplateRows: "none",
      },
   },
   colHeaderFeatures: {
      padding: "0px 16px 16px",
      color: "#fff",
      fontWeight: 700,
      fontSize: "24px",
   },
   colHeaderPepper: {
      padding: "20px 24px 16px",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "24px",
      textAlign: "left",
   },
   colHeaderOther: {
      padding: "0px 16px 16px",
      color: "#fff",
      fontWeight: 700,
      fontSize: "24px",
      textAlign: "left",
   },
   cellFeature: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
      padding: "20px",
      "&:nth-child(even)": {
         background: "rgba(255, 255, 255, 0.05)",
      },
      "&:nth-child(2)": {
         borderRadius: "14px 0 0 0",
      },
      "&:last-child": {
         borderRadius: "0 0 0 14px",
      },
      [theme.breakpoints.down("sm")]: {
         padding: "16px",
         "&:nth-child(2)": {
            borderRadius: "14px 14px 0 0",
         },
         "&:last-child": {
            borderRadius: "0 0 14px 14px",
         },
      },
   },
   cellPepper: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "20px",
      [theme.breakpoints.down("sm")]: {
         padding: "16px",
      },
   },
   cellOther: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "20px",
      "&:nth-child(even)": {
         background: "rgba(255, 255, 255, 0.05)",
      },
      "&:nth-child(2)": {
         borderRadius: "0 14px 0 0",
      },
      "&:last-child": {
         borderRadius: "0 0 14px 0",
      },
      [theme.breakpoints.down("sm")]: {
         padding: "16px",
         "&:nth-child(2)": {
            borderRadius: "14px 14px 0 0",
         },
         "&:last-child": {
            borderRadius: "0 0 14px 14px",
         },
      },
   },
   featureIconBox: {
      width: "42px",
      height: "42px",
      borderRadius: "6px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      "& svg": { fontSize: "20px" },
   },
   featureName: {
      color: "#ffffff",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: 1.4,
   },
   cellTickImg: {
      width: "22px",
      height: "22px",
      flexShrink: 0,
   },
   cellXIcon: {
      color: "#fff",
      fontSize: "24px !important",
      flexShrink: 0,
   },
   cellText: {
      color: "#fff",
      fontSize: "16px",
      lineHeight: 1.65,
   },
   cellTextOther: {
      color: "#fff",
      fontSize: "16px",
      lineHeight: 1.65,
   },
   pricingDemoBtn: {
      justifyContent: "center !important",
      textDecoration: "none !important",
      display: "flex !important",
      margin: "auto",
      zIndex: "1 !important",
      padding: "15px 35px !important",
   },
   sectionTitle: {
      color: "#fff",
      fontSize: "56px",
      fontWeight: 600,
      textAlign: "center",
      marginBottom: "48px",
      lineHeight: 1.2,
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
         marginBottom: "32px",
      },
   },
   trustedByLogoOuter: {
      position: "relative",
      backgroundColor:"hsla(0,0%,100%,1)",
      backgroundImage:"radial-gradient(at 97% 2%, hsla(273,100%,93%,1) 0px, transparent 50%),radial-gradient(at 0% 0%, hsla(206,100%,90%,1) 0px, transparent 50%)",
      paddingBottom: "18%",
      paddingTop: "12%",
      [theme.breakpoints.down("sm")]: {
         paddingBottom: "40%",
         paddingTop: "30%",
      },
      [theme.breakpoints.down("xs")]: {
         paddingBottom: "40%",
         paddingTop: "60%",
      },
      "@media(max-width:400px)": {
         paddingBottom: "55%",
         paddingTop: "75%",
      },
   },
   trustedSectionOverlay: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      transform: "translateY(50%)",
      zIndex: 2,
   },
   testimonialWrapper: {
      paddingTop: "15%",
      paddingBottom: "20px",
      background: "rgba(255, 247, 241, 1)",
      "@media(max-width:1200px)": {
         paddingTop: "20%",
      },
      [theme.breakpoints.down("sm")]: {
         paddingTop: "30%",
      },
      [theme.breakpoints.down("xs")]: {
         paddingTop: "40%",
      },
      "@media(max-width:400px)": {
         paddingTop: "50%",
      },
   },
}));

const pricingCardDetails = [
   {
      title: "Starter",
      user: "Upto 5 Users",
      description1: "Small businesses.",
      description2: "Powerful AI CRM for teams getting started.",
      logo: pricingIcon1,
      alt: "Starter pricing plan for small businesses",
      variant: "starter",
   },
   {
      title: "Growth",
      user: "10 - 12 Users",
      description1: "Growing teams.",
      description2:
         "Dynamic CRM tool for medium-level organisations scaling up.",
      logo: pricingIcon2,
      alt: "Growth pricing plan for growing businesses",
      variant: "growth",
      badge: "The growth catalyst",
      middle: true,
   },
   {
      title: "Enterprise",
      user: "50+ Users",
      description1: "Large companies.",
      description2:
         "Productive, high-volume CRM system for established enterprises.",
      logo: pricingIcon3,
      alt: "Enterprise pricing plan for large companies",
      variant: "enterprise",
   },
];
const comparisonData = [
   {
      feature: "AI capabilities",
      icon: featuresIcon1,
      iconBg:
         "linear-gradient(45deg,rgba(29, 141, 238, 1) 0%, rgba(16, 81, 136, 1) 100%)",
      pepperCloud:
         "AssistAI automates routine tasks, improves communication instantly, 24/7 multichannel AI chatbot, and streamlines chatflow automation.",
      otherCrm:
         "Provides basic AI with limited intelligence and relies on add-ons for advanced features.",
   },
   {
      feature: "WhatsApp integration",
      icon: featuresIcon2,
      iconBg:
         "linear-gradient(45deg,rgba(2, 145, 174, 1) 0%, rgba(1, 60, 72, 1) 100%)",
      pepperCloud:
         "Delivers native WhatsApp CRM with Cloud API, automation, templates, broadcasts, and seamless chat-to-deal workflows.",
      otherCrm:
         "Depends on plugins and lacks a unified WhatsApp-to-sales flow.",
   },
   {
      feature: "Sales management",
      icon: featuresIcon3,
      iconBg: "linear-gradient(45deg, #FF8B3D 0%, #995325 100%)",
      iconColor: "#FF8F61",
      pepperCloud:
         "Supports multi-pipeline sales, automated lead capture, real-time updates, deep analytics, and mobile CRM.",
      otherCrm: "Requires expensive third-party add-ons or complex APIs.",
   },
   {
      feature: "Support CRM",
      icon: featuresIcon4,
      iconBg: "linear-gradient(45deg, #9E5AD5 0%, #522F6F 100%)",
      iconColor: "#9E5AD5",
      pepperCloud:
         "Includes WhatsApp-based support, multichannel handling, SLA tracking, and round-robin assignment in one system.",
      otherCrm:
         "Requires separate tools, creating fragmented support communication.",
   },
   {
      feature: "Security",
      icon: featuresIcon5,
      iconBg:
         "linear-gradient(45deg,rgba(29, 141, 238, 1) 0%, rgba(16, 81, 136, 1) 100%)",
      iconColor: "#05B2B1",
      pepperCloud:
         "Provides multi-layer security with encryption, MFA, granular permissions, and rigorous testing.",
      otherCrm:
         "Offers standard security with limited enterprise-level controls.",
   },
];

const Plans = [
   {
      title: "Seamless Customer Support",
      logo: SeamlessCustomerSupport,
      alt: "Headphone icon - the best customer support by the best CRM system ",
   },
   {
      title: "Effortless Migration",
      logo: EffortlessMigration,
      alt: "Icon to indicate effortless migration with various CRM pricing models",
   },
   {
      title: (
         <>
            Preeminent{" "}
            <a href="https://peppercloud.com/crm-data-security-protection/">
               {" "}
               Data Security
            </a>
         </>
      ),
      logo: PreminentDataSecurity,
      alt: "Icon to indicate data security with every crm pricing model",
   },
];

function Pricing() {
   const width = useWidth();
   const classes = useStyles();

   const [customerPrefer, setCustomerPrefer] = React.useState(0);

   const [expanded, setExpanded] = React.useState(0);

   const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
   };

   useEffect(() => {
      const gradients = [
         "rgba(5, 178, 177, 0.5)",
         "rgba(0, 137, 255, 0.8)",
         "rgba(150, 90, 220, 0.5)",
      ];
      const cards = document.querySelectorAll(`.${classes.newPriceCard}`);

      cards.forEach((card, index) => {
         card.classList.add("glass-effect");
         card.style.setProperty(
            "--before-gradient",
            gradients[index % gradients.length],
         );

         const getInitialPos = () => {
            const rect = card.getBoundingClientRect();
            return { x: rect.width - 250, y: -150 };
         };

         const setInitialPosition = () => {
            const { x, y } = getInitialPos();
            card.style.setProperty("--before-left", `${x}px`);
            card.style.setProperty("--before-top", `${y}px`);
         };

         setInitialPosition();

         const handleMouseMove = (e) => {
            card.style.setProperty("--before-transition", "0s");
            const rect = card.getBoundingClientRect();
            card.style.setProperty(
               "--before-left",
               `${e.clientX - rect.left - 250}px`,
            );
            card.style.setProperty(
               "--before-top",
               `${e.clientY - rect.top - 250}px`,
            );
         };

         const handleMouseLeave = () => {
            card.style.setProperty("--before-transition", "0.6s");
            const { x, y } = getInitialPos();
         };

         card._pricingHandlers = {
            mousemove: handleMouseMove,
            mouseleave: handleMouseLeave,
            resize: setInitialPosition,
         };
         card.addEventListener("mousemove", handleMouseMove);
         card.addEventListener("mouseleave", handleMouseLeave);
         window.addEventListener("resize", setInitialPosition);
      });

      return () => {
         cards.forEach((card) => {
            const h = card._pricingHandlers;
            if (h) {
               card.removeEventListener("mousemove", h.mousemove);
               card.removeEventListener("mouseleave", h.mouseleave);
               window.removeEventListener("resize", h.resize);
            }
         });
      };
   }, [classes]);

   useEffect(() => {
      const card = document.querySelector(`.${classes.pepperCloudCard}`);
      if (!card) return;

      card.classList.add("glass-effect");
      card.style.setProperty("--before-gradient", "rgba(5, 178, 177, 0.55)");

      const getInitialPos = () => {
         const rect = card.getBoundingClientRect();
         return { x: rect.width - 175, y: -120 };
      };

      const setInitialPosition = () => {
         const { x, y } = getInitialPos();
         card.style.setProperty("--before-left", `${x}px`);
         card.style.setProperty("--before-top", `${y}px`);
      };

      setInitialPosition();

      const handleMouseMove = (e) => {
         card.style.setProperty("--before-transition", "0s");
         const rect = card.getBoundingClientRect();
         card.style.setProperty(
            "--before-left",
            `${e.clientX - rect.left - 175}px`,
         );
         card.style.setProperty(
            "--before-top",
            `${e.clientY - rect.top - 175}px`,
         );
      };

      const handleMouseLeave = () => {
         card.style.setProperty("--before-transition", "0.6s");
         const { x, y } = getInitialPos();
      };

      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);

      return () => {
         card.removeEventListener("mousemove", handleMouseMove);
         card.removeEventListener("mouseleave", handleMouseLeave);
         window.removeEventListener("resize", setInitialPosition);
      };
   }, [classes]);

   const prefer = [
      {
         title: "Boosts your sales",
         description:
            "With various CRM features and functionalities, Pepper Cloud helps you efficiently deliver remarkable experiences to your customers and increase sales manifold.",
      },
      {
         title: "Saves time and effort",
         description: (
            <>
               Provide the freedom your sales team deserves by organising your{" "}
               <a href="https://peppercloud.com/sales-pipeline-management-tool/">
                  pipeline{" "}
               </a>
               , strategising the process, and{" "}
               <a href={"https://peppercloud.com/integration"}>
                  visualising the performance
               </a>
               .
            </>
         ),
      },
      {
         title: "No shuffling between tools",
         description: (
            <>
               Integrate the sales-boosting tools with Pepper Cloud CRM and
               avoid sifting through multiple tools. Work efficiently with
               plug-and-play
               <a href="https://peppercloud.com/integration">
                  CRM system integrations
               </a>
               .
            </>
         ),
      },
   ];
   const FAQ = [
      {
         question: "How can we choose among various pricing options?",
         answer:
            "Choose the starter pack from the CRM system price plans if you are moving from the manual or spreadsheet management to CRM. Business Plan is good for companies who are already using an existing CRM but now shifting to a cloud-based solution. For big and heavy users, enterprise plans are the best as it comes with unlimited priority support.",
      },
      {
         question:
            "Can we change our pricing plan in between our billing period?",
         answer: (
            <>
               You can move from the monthly billing cycle to the annual billing
               cycle anytime you want. However, we do not support moving from a
               yearly plan to a monthly plan before the expiry of the period.
               For shifting to enterprise-level plans, please{" "}
               <a href="https://peppercloud.com/contact/">
                  {" "}
                  contact our sales team
               </a>
               .
            </>
         ),
      },
      {
         question: "What language does Pepper Cloud CRM support?",
         answer:
            "Currently, Pepper Cloud is available only in English. Soon, you will enjoy our services in Thai, Chinese (Simplified) and Bahasa.",
      },
      {
         question: "Can I export all my data if I stop using Pepper Cloud CRM?",
         answer:
            "Absolutely! Your data is your property so you can take export of your data whenever you like. You can also schedule an automatic data export with Pepper Cloud.",
      },
      {
         question: "How to avail business grant for Pepper Cloud CRM?",
         answer: (
            <>
               <a href="https://peppercloud.com/contact/">Contact</a> our
               friendly customer support. They will help you. You can learn more
               about{" "}
               <a href="https://blog.peppercloud.com/edge-grant-singapore-a-comprehensive-guide-to-digitalisation-funding-for-businesses/">
                  {" "}
                  Business grants
               </a>{" "}
               on our blog.
            </>
         ),
      },
       {
         question: "Are there any setup or hidden fees included in the AI WhatsApp CRM costs?",
         answer: "There are no hidden fees for standard setup. All features and onboarding are included in the pricing plan.",
      },
      {
         question: "What happens if my team grows or volume increases?",
         answer: "You can scale to a higher plan (e.g., business to enterprise) and adjust for additional users or WhatsApp volume. The pricing is designed to scale with your business.",
      },
      {
         question: "Does the pricing cover both sales features and support features?",
         answer: "Yes. The pricing plans cover the full AI CRM platform: sales pipelines, WhatsApp CRM, AI automation, support workflows and multichannel communication.",
      },
      {
         question: "How secure is the platform, and does security affect CRM pricing?",
         answer: "Pepper Cloud includes multi-layered security, encryption, two-factor authentication and team access controls. These enterprise-grade security features come built into the pricing tiers rather than being additive. ",
      },
   ];
   return (
      <div>
         <SEO
            canonical="/crm-platfrom-pricing/"
            description="Stop paying on multiple tools to manage your sales business. Just get All-in-One sales CRM at most affordable CRM system pricing - Starter, business, and enterprise plan"
            keywords="CRM Pricing, 
        CRM platfrom pricing,
				pricing plans,
				CRM online pricing,
				CRM system price,
				CRM price"
            pathname="/crm-platfrom-pricing/"
            title="CRM Platfrom Pricing Plan | Pepper Cloud CRM"
         />
         <Box className={classes.root}>
            <Box className="container">
               <Box
                  alignItems="center"
                  className={classes.header}
                  component={Container}
                  display="flex !important"
                  flexDirection="column"
                  textAlign="center"
               >
                  <motion.div
                     initial={{ opacity: 0, x: -20 }}
                     whileInView={{ opacity: 1, x: 0 }}
                     transition={{ duration: 0.5 }}
                     viewport={{ once: false }}
                  >
                     <HeaderTypography
                        className={classes.bannerHeading}
                        overrideClassName
                        component="h1" 
                        fontWeight={600}
                        lineHeight={1.2}
                        my={3}
                     >
                        <Box component="span" className={classes.gradientText}>
                           AI WhatsApp CRM
                        </Box>{" "}
                        pricing: <br/> Choose the right plan for your business growth
                     </HeaderTypography>
                  </motion.div>

                  <motion.div
                     initial={{ opacity: 0, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5, delay: 0.15 }}
                     viewport={{ once: false }}
                  >
                     <ParagraphTypography
                        fontSize={18}
                        m={0}
                        fontWeight={500}
                        color={"#000"}
                     >
                        Pepper Cloud is the all-in-one AI WhatsApp CRM that
                        seamlessly unites your sales and support operations.
                     </ParagraphTypography>
                  </motion.div>

                  <motion.div
                     initial={{ opacity: 0, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5, delay: 0.25 }}
                     viewport={{ once: false }}
                  >
                     <Box
                        display="flex"
                        flexWrap="wrap"
                        justifyContent="center"
                        mt={3}
                        className={classes.featureChipsContainer}
                     >
                        {[
                           "AI-powered automation",
                           "No hidden charges",
                           "Local support 24/7",
                        ].map((item) => (
                           <Box key={item} className={classes.featureChip}>
                              <Box
                                 component="img"
                                 src={tick}
                                 alt=""
                                 width={24}
                                 height={24}
                              />
                              <Typography fontSize={18}>{item}</Typography>
                           </Box>
                        ))}
                     </Box>
                  </motion.div>
               </Box>
               <Box className={classes.pricingCardsContainer}>
                  {pricingCardDetails.map((tier, index) => {
                     const cardClass = {
                        starter: classes.newStarterCard,
                        growth: classes.newGrowthCard,
                        enterprise: classes.newEnterpriseCard,
                     }[tier.variant];
                     return (
                           <motion.div
                           key={tier.title}
                           initial={{ opacity: 0, y: 60 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.8, delay: index * 0.1 }}
                           viewport={{ once: false }}
                              className={`${classes.cardWrapper}${
                                 tier.badge
                                    ? ` ${classes.cardWrapperBadge}`
                                    : ""
                              }`}
                           >
                              {tier.badge && (
                                 <Box
                                    component="span"
                                    className={classes.mostPopularBadge}
                                 >
                                    {tier.badge}
                                 </Box>
                              )}
                              <Box
                                 className={`${
                                    classes.newPriceCard
                                 } ${cardClass}${
                                    tier.middle
                                       ? ` ${classes.newPriceCardMiddle}`
                                       : ""
                                 }`}
                              >
                                 <Box
                                    mb={2}
                                    className={`${classes.pricingIconCircle} ${classes.iconBgDark}`}
                                 >
                                    <Box
                                       component="img"
                                       src={tier.logo}
                                       alt={tier.alt}
                                       width={28}
                                       height={28}
                                    />
                                 </Box>
                                 <Box
                                    component="h2"
                                    fontSize="18px"
                                    fontWeight="700"
                                    mb={2}
                                    className={classes.cardTitle}
                                 >
                                    {tier.title}
                                 </Box>
                                 <Box
                                    fontSize="24px"
                                    fontWeight="600"
                                    mb={1}
                                    className={classes.cardUserCount}
                                 >
                                    {tier.user}
                                 </Box>
                                 <Box
                                    fontSize="15px"
                                    mb={1}
                                    className={classes.cardDescription}
                                 >
                                    <Box
                                       component="span"
                                       fontWeight="600"
                                       className={classes.cardBestForLabel}
                                    >
                                       Best for:
                                    </Box>{" "}
                                    {tier.description1}
                                 </Box>
                                 <Box
                                    fontSize="15px"
                                    mb={2}
                                    className={classes.cardDescription}
                                 >
                                    {tier.description2}
                                 </Box>
                                 <Link
                                    to="/contact/"
                                    className={`${
                                       tier.middle
                                          ? "primaryButton"
                                          : "loginButton"
                                    } font-wix-regular font-white ${
                                       classes.pricingDemoBtn
                                    }`}
                                 >
                                    Get demo
                                 </Link>
                              </Box>
                           </motion.div>
                     
                     );
                  })}
               </Box>

               <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  viewport={{ once: false }}
               >
                  <Box mt={5} textAlign="center" px={2}>
                     <ParagraphTypography
                        fontSize={16}
                        fontWeight={500}
                        color={"#000"}
                     >
                        Avail up to 50% business grant support on Pepper Cloud AI
                        WhatsApp CRM.{" "}
                        <a
                           href="https://blog.peppercloud.com/ultimate-guide-to-productivity-solutions-grant/"
                           className={classes.pricingReadMoreLink}
                        >
                           Read more
                        </a>{" "}
                        <br />
                        <span className="font-wix-bold">
                           Need a bespoke solution?
                        </span>{" "}
                        <Link to="/contact/">Contact our sales team</Link> for a
                        quote tailored to your specific requirements.
                     </ParagraphTypography>
                  </Box>
               </motion.div>

                 <motion.div
                     initial={{ opacity: 0, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5, delay: 0.2 }}
                     viewport={{ once: false }}
                  >
                     <IMDALockup />
                  </motion.div>
            </Box>
         </Box>

         <Box className={classes.crmAdvantageSection}>
            <Box
               alignItems="center"
               component={Container}
               display="flex !important"
               flexDirection="column"
               textAlign="center"
               mb={6}
            >
               <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  <HeaderTypography
                     className={classes.sectionTitle}
                     overrideClassName
                     component="h2"
                     fontWeight={600}
                     lineHeight={1.2}
                     my={3}
                     color="common.white"
                  >
                     Find your perfect AI WhatsApp CRM advantage
                  </HeaderTypography>
               </motion.div>

               <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.15 }}
                  viewport={{ once: false }}
               >
                  <ParagraphTypography
                     fontSize={18}
                     m={0}
                     color="white"
                     fontWeight={500}
                  >
                     We don&apos;t just manage your data, we use artificial
                     intelligence and generative AI to drive revenue. See how
                     our AI CRM stands up against older, non-integrated systems.
                  </ParagraphTypography>
               </motion.div>
            </Box>

            <motion.div
               initial={{ opacity: 0, y: 60 }}
               whileInView={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.8, delay: 0.1 }}
               viewport={{ once: false }}
            >
               <div className="container">
                  <Box className={classes.comparisonGrid}>
                     {/* Features column */}
                     <Box className={classes.featuresColumn}>
                        <Box className={classes.colHeaderFeatures}>
                           Features
                        </Box>
                        {comparisonData.map((row) => (
                           <Box
                              key={row.feature}
                              className={classes.cellFeature}
                           >
                              <Box
                                 className={classes.featureIconBox}
                                 style={{ background: row.iconBg }}
                              >
                                 <Box
                                    component="img"
                                    src={row.icon}
                                    alt={row.feature}
                                    width={24}
                                    height={24}
                                 />
                              </Box>
                              <Box className={classes.featureName}>
                                 {row.feature}
                              </Box>
                           </Box>
                        ))}
                     </Box>

                     {/* Pepper Cloud card — single element for hover effect */}
                     <Box className={classes.pepperCloudCard}>
                        <Box className={classes.colHeaderPepper}>
                           Pepper Cloud
                        </Box>
                        {comparisonData.map((row) => (
                           <Box
                              key={row.feature}
                              className={classes.cellPepper}
                           >
                              <Box
                                 component="img"
                                 src={tick}
                                 alt="check"
                                 className={classes.cellTickImg}
                              />
                              <Box className={classes.cellText}>
                                 {row.pepperCloud}
                              </Box>
                           </Box>
                        ))}
                     </Box>

                     {/* Other CRMs column */}
                     <Box className={classes.otherCrmsColumn}>
                        <Box className={classes.colHeaderOther}>Other CRMs</Box>
                        {comparisonData.map((row) => (
                           <Box key={row.feature} className={classes.cellOther}>
                              <RemoveCircleOutline
                                 className={classes.cellXIcon}
                              />
                              <Box className={classes.cellTextOther}>
                                 {row.otherCrm}
                              </Box>
                           </Box>
                        ))}
                     </Box>
                  </Box>
               </div>
            </motion.div>

            {/* Award card — absolutely positioned to straddle both sections */}
            <div className={classes.awardCardOuter}>
               <div className="container">
                  <Box className={classes.awardCardWrapper}>
                     {/* Left: heading + description */}
                     <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.15 }}
                        viewport={{ once: false }}
                        className={classes.awardCardLeft}
                     >
                        <Box
                           component="h3"
                           className={classes.awardCardHeading}
                        >
                           Industry recognition and achievements
                        </Box>
                        <Box component="p" className={classes.awardCardText}>
                           We are proud to be acknowledged for our innovative
                           approach to combining AI, Sales, Support, and
                           WhatsApp into a single, powerful platform.
                        </Box>
                     </motion.div>

                     {/* Right: Trailblazers award card */}
                     <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.15 }}
                        viewport={{ once: false }}
                        className={classes.awardCardRight}
                     >
                        <Box className={classes.trailBazarCard}>
                           <Box
                              component="img"
                              src={leavesLeft}
                              alt=""
                              className="leaves leavesLeft"
                           />
                           <Box className={classes.trailBazarInner}>
                              <Box component="img" src={stars} alt="stars" />
                              <Box
                                 component="p"
                                 className={`${classes.trailBazarTitle} font-wix-bold`}
                              >
                                 Transformation Award 2024
                              </Box>
                              <Box
                                 component="p"
                                 className={classes.trailBazarDesc}
                              >
                                 Pepper Cloud is awarded the Google AI
                                 Trailblazers Transformation Award 2024 under a
                                 Singapore government and Google Cloud
                                 initiative, recognising our AI-powered WhatsApp
                                 Sales CRM.
                              </Box>
                              <Box
                                 component="img"
                                 src={trailBazarLogo}
                                 alt="Google Trailblazers"
                                 className="trailblazerLogo"
                              />
                           </Box>
                           <Box
                              component="img"
                              src={leavesRight}
                              alt=""
                              className="leaves leavesRight"
                           />
                        </Box>
                     </motion.div>
                  </Box>
               </div>
            </div>
         </Box>
            <Box className={classes.trustedByLogoOuter}>
               <TrustedByLogoStrip title={"Trusted by leading SMB globally"} />
               <Box className={classes.trustedSectionOverlay}>
                  <TruestedSection background={true} />
               </Box>
            </Box>

            <Box className={classes.testimonialWrapper}>
               <TestimonialSlider
                  heading="Trusted by sales and support teams around the world"
                  desc="Discover how businesses are transforming customer engagement with Pepper Cloud."
                  noButton={true}
                  background="transparent"
               />
            </Box>

         <FaqSection
            backgroundColor="#fff"
            heading="CRM pricing plans- Frequently asked questions"
            faqs={FAQ}
            noMobilePadding={true}
         />
         <Box className={classes.JoinRoot}>
            <Container>
               <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  <HeaderTypography
                     className={classes.joinHeading}
                     color="common.white"
                     component="h2"
                     lineHeight={1.2}
                     mt={0}
                     textAlign="center"
                  >
                     Predict. Plan. Profit: <br />
                     Take control of your sales future!
                  </HeaderTypography>
               </motion.div>
               <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  viewport={{ once: false }}
                  style={{ display: "flex", justifyContent: "center" }}
               >
                  <Box display="flex" justifyContent="center">
                     <Link
                        className={`primaryButton font-20 colorWhite`}
                        to="/contact/?utm_source=Pricing&utm_medium=Book+a+free+demo"
                     >
                        Book a free demo
                     </Link>
                  </Box>
               </motion.div>
            </Container>
         </Box>
      </div>
   );
}

export default Pricing;
